import React from 'react';

const TransitionCTA: React.FC = () => {
  return (
    <section className="py-12 sm:py-16 bg-navy-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4">
          We also work with agencies.
        </h2>
        <p className="text-navy-200 text-lg max-w-2xl mx-auto">
          If you're running an IMO and want to scale your operation, we can help. 
          Custom lead stores, dialer setups, recruiting systems, the whole infrastructure.
        </p>
        <div className="mt-6 flex justify-center gap-6 text-sm text-navy-300">
          <span>Lead generation</span>
          <span>•</span>
          <span>Premium support</span>
          <span>•</span>
          <span>Agency tools</span>
        </div>
      </div>
    </section>
  );
};

export default TransitionCTA;
